<template>
  <div class="bill">
    <div class="card info">
      <div class="title">{{ insureDetail.insuranceName }}</div>
      <div
        class="mark"
        :style="{ backgroundImage: background.backgroundImage2 }"
      >
        <div>保险要求:</div>
        <div v-html="insureDetail.insuranceDesc"></div>
        <!-- <div>① 累计赔偿限额≥100万</div>
        <div>② 每次事故赔偿限额≥100万</div>
        <div>③ 每人每次事故赔偿限额≥50万</div> -->
      </div>
    </div>

    <div class="card status">
      <div class="title">审核进度</div>

      <van-steps
        direction="vertical"
        :active="0"
        active-color="#CCCCCC"
        inactive-color="#CCCCCC"
      >
        <template v-for="(item, index) in workflowVos">
          <van-step :key="index">
            <template #inactive-icon>
              <div class="inactive-icon"></div>
            </template>
            <template #active-icon>
              <div class="active-icon"></div>
            </template>
            <template #finish-icon>
              <div class="active-icon"></div>
            </template>

            <div class="step-body">
              <div class="line">
                <div class="name">
                  <span class="name1">{{ item.handler }}</span>
                  <span class="name2">{{ item.role }}</span>
                </div>
                <div>
                  <span class="time">{{ item.handleTime }}</span>
                </div>
              </div>
              <div class="line">
                <span class="status1">{{ item.approvalComments }}</span>
                <span class="status2 status3">{{ item.statusName }}</span>
              </div>
            </div>
          </van-step>
        </template>
      </van-steps>

      <template v-if="insureDetail.workflowVos.length > 2">
        <div class="action" @click="handleAction('more')" v-if="!action">
          展开<van-icon name="arrow-down" />
        </div>
        <div class="action" @click="handleAction('less')" v-else>
          收起<van-icon name="arrow-up" />
        </div>
      </template>
    </div>

    <div class="card form">
      <div class="title">审核内容</div>

      <van-cell-group>
        <van-cell
          title="保单生效时间"
          :value="`${formatDate(insureDetail.startDate)}-${formatDate(
            insureDetail.endDate
          )}`"
        />
        <van-cell title="保险公司" :value="insureDetail.insuranceCompanyName" />
        <van-cell class="form3" title="保单图片" value="" />
        <div class="img-list">
          <template v-for="(item, index) in insureDetail.picUrl">
            <img
              :key="index"
              :src="item"
              @click="handlePreview(insureDetail.picUrl, index)"
            />
          </template>
        </div>
      </van-cell-group>
    </div>

    <div v-if="insureDetail.status == 1 || insureDetail.status == 2" class="submit" @click="reSubmit">
      重新提交
    </div>
  </div>
</template>
<script>
import { CellGroup, Step, Cell, Steps, ImagePreview } from 'vant';
import moment from 'moment';
import { ApiGetInsurDetail } from '@/api/insurance';

export default {
  name:'insure_detail',
  components: {
    VanCellGroup: CellGroup,
    VanCell: Cell,
    VanSteps: Steps,
    VanStep: Step,
  },
  computed: {
    plazaId() {
      return this.$store.state.account.plazaId;
    },
    plazaName() {
      return this.$store.state.account.plazaName;
    },
    storeId() {
      return this.$store.state.account.storeId;
    },

    storeName() {
      return this.$store.state.base.storeName;
    },
    bunkDesc() {
      return this.$store.state.base.bunkDesc;
    },

    insuranceId() {
      return this.$route.query.insuranceId;
    },
    insuranceName() {
      return this.$route.query.insuranceName;
    },
    insuranceDesc() {
      return this.$route.query.insuranceDesc;
    },
  },
  data() {
    return {
      background: {
        backgroundImage2: 'url(' + require('./img/edit_img.png') + ')',
      },
      showCalendar: false,
      date: '',
      insureDetail: {},
      workflowVos: [],
      action: false,
    };
  },
  methods: {
    getDetail() {
      let data = {
        insuranceId: this.insuranceId,
        plazaId: this.plazaId,
        storeId: this.storeId,
        source: 1,
      };
      ApiGetInsurDetail(data).then((res) => {
        res.picUrl = res.picUrl.split(',');
        this.insureDetail = res;
        this.workflowVos = res.workflowVos.slice(0, 2);
      });
    },
    formatDate(date) {
      return moment(date).format('YYYY.MM.DD');
    },
    onConfirm(date) {
      const [start, end] = date;
      this.showCalendar = false;
      this.date = `${moment(start).format('YYYY.MM.DD')} - ${moment(end).format(
        'YYYY.MM.DD'
      )}`;
    },
    handleAction(type) {
      if (type == 'more') {
        this.action = true;
        this.workflowVos = this.insureDetail.workflowVos;
      } else {
        this.action = false;
        this.workflowVos = this.insureDetail.workflowVos.slice(0, 2);
      }
    },
    reSubmit() {
      this.$router.replace({
        path: '/insure_edit',
        query: {
          id: this.insureDetail.id,

          insuranceId: this.insureDetail.insuranceId,
          insuranceName: this.insureDetail.insuranceName,
          insuranceDesc: this.insureDetail.insuranceDesc,
        },
      });
    },
    handlePreview(picUrl, index) {
      ImagePreview({
        images: picUrl,
        startPosition: index,
      });
    },
  },
  mounted() {
    console.log();
    this.insuranceId = this.$route.query.insuranceId;
    this.getDetail();
  },
};
</script>

<style lang="less" scoped>
.bill {
  background: #f3f5f6;
  padding: 12px;
  text-align: left;
  line-height: 1;
  overflow: auto;
  box-sizing: border-box;
  .card {
    margin-top: 12px;
    background: #ffffff;
    border-radius: 8px;
    padding: 16px 12px 12px 12px;
    .title {
      font-size: 16px;
      font-weight: 500;
      color: #111111;
      margin-bottom: 12px;
    }
    .action {
      text-align: center;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 16px;
    }
    .img-list {
      img {
        width: 101px;
        height: 101px;
        border-radius: 4px;
        border: 1px solid #e7e7e7;
      }
    }
  }
  .info {
    .mark {
      background: #fff3f3;
      font-size: 12px;
      font-weight: 400;
      color: #666666;
      line-height: 20px;
      padding: 8px;
      border-radius: 8px;

      background-position: right bottom;
      background-repeat: no-repeat;
      background-size: 66px 59px;

      white-space: pre-wrap;
    }
  }

  .status {
    .inactive-icon {
      width: 8px;
      height: 8px;
      background-color: #ccc;
      border: 4px solid #eee;
      border-radius: 50%;
    }
    .active-icon {
      width: 8px;
      height: 8px;
      background-color: #ff1d1d;
      border: 4px solid #ffdbdb;
      border-radius: 50%;
    }
    .step-body {
      font-size: 14px;
      font-weight: 400;

      .line {
        display: flex;
        justify-content: space-between;
        margin-bottom: 8px;
        .name1 {
          color: #666666;
        }
        .name2 {
          margin-left: 8px;
          font-size: 12px;
          color: #999999;
        }
        .time {
          color: #999999;
        }

        .status1 {
          color: #999999;
        }
        .status2 {
          color: #666666;
        }
        .status2 {
          color: #fc9127;
        }
      }
    }

    // /deep/.van-step__line {
    //   background: none !important;
    //   border-left: 1px dashed;
    // }
  }

  .form {
    .van-cell_title {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }
    .van-cell__value {
      flex: 2;
      font-size: 14px;
      font-weight: 400;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #111111;
    }
    .van-cell {
      padding-left: 0;
      padding-right: 0;
    }
    .van-cell::after {
      left: 0;
      right: 0;
    }

    .form3::after {
      display: none;
    }
    /deep/.van-hairline--top-bottom::after {
      border: none;
    }

    .van-uploader {
      /deep/.van-uploader__upload {
        // border-radius: 6px;
        background-color: #f5f5f5;
        // overflow: hidden;
      }
      /deep/.van-icon-photograph {
        font-size: 34px;
      }
      /deep/.van-uploader__upload-text {
        margin-top: 0;
      }
      /deep/.van-image__img {
        // border-radius: 8px;
      }
    }
  }

  .submit {
    margin-top: 12px;
    width: 100%;
    height: 44px;
    line-height: 44px;
    background: linear-gradient(270deg, #ff8366 0%, #ff1d1d 100%);
    border-radius: 22px;
    text-align: center;
    color: #fff;
    font-size: 18px;
    font-weight: 500;
    color: #ffffff;
  }
}
</style>